import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


if ($('.gallery-slider')) {

	const gallerySlider = new Swiper('.gallery-slider .swiper', {
		loop: true,
		loopedSlides: 4,
		centeredSlides: true,
		slidesPerView: 'auto',
		spaceBetween: 25,
		speed: 1000,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		}
	});

	$('.gallery-slider .next').on('click', function() {
		gallerySlider.slideNext();
	});

	$('.gallery-slider .prev').on('click', function() {
		gallerySlider.slidePrev();
	});
}
